// import { createBrowserHistory } from 'history';
// export const history = createBrowserHistory();

// import createHistory from 'history/createBrowserHistory'
const createHistory = require("history").createBrowserHistory
export const history = createHistory()